module.exports = __webpack_public_path__ + "img/01.41bc7d4e.jpg";